import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SettingsHttpService } from '../../../../core/settings';
import { Cache } from 'aws-amplify';

@Component({
  selector: 'kt-connection-logs',
  templateUrl: './connection-logs.component.html',
  styleUrls: ['./connection-logs.component.scss']
})
export class ConnectionLogsComponent implements OnInit {
	connLogs;
	selectedMachine = Cache.getItem('selected_machine');
  constructor(private http: SettingsHttpService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
	  this.getConnStatusLog();
  }

  getConnStatusLog() {
	  this.http.getMacConnLogs(this.selectedMachine.m_id)
	  .subscribe(logs => {
		this.connLogs = logs.data;
		console.log(this.connLogs);
		this.cdr.detectChanges();
	  });
  }

}
